module.exports = __webpack_public_path__ + "static/media/caret-down-black.89a787a9.svg";